module.exports = __webpack_public_path__ + "img/sen_temp.dc1b663f.png";